import script from "./IntroSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./IntroSection.vue?vue&type=script&setup=true&lang=ts"

import "./IntroSection.vue?vue&type=style&index=0&id=2b7dbc50&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b7dbc50"]])

export default __exports__